import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { Loader } from "../../components";
import { GGV_GET_AVAILABLE_DATES } from "../../queries";

const GGVScheduleVerifyAvailableDates = ({
  RenderSuccess,
  RenderFailure,
  groupCode
}) => {
  const { data, loading } = useQuery(GGV_GET_AVAILABLE_DATES, {
    variables: {
      groupCode
    }
  });

  if (loading || !data) return <Loader />;

  const { ggvAvailableDates } = data;

  return (
    <>
      {ggvAvailableDates &&
      Array.isArray(ggvAvailableDates.available_dates) &&
      ggvAvailableDates.available_dates.length > 0 ? (
        <RenderSuccess groupCode={groupCode} />
      ) : (
        <RenderFailure groupCode={groupCode} />
      )}
    </>
  );
};

export { GGVScheduleVerifyAvailableDates };
